import { CMSSectionElement } from "./CMSSectionElement";

export default CMSSectionElement;
